'use client';
import { useRef } from 'react';
import { isFunction } from '@s7/utils';
import { useDidUpdate } from '../useDidUpdate/useDidUpdate.js';

/** Возвращает фокус элементу, который последним был активен */ function useFocusReturn(options) {
    var opened = options.opened, _options_shouldReturnFocus = options.shouldReturnFocus, shouldReturnFocus = _options_shouldReturnFocus === void 0 ? true : _options_shouldReturnFocus;
    var lastActiveElement = useRef();
    var returnFocus = function() {
        if (lastActiveElement.current && "focus" in lastActiveElement.current && isFunction(lastActiveElement.current.focus)) {
            var _lastActiveElement_current;
            (_lastActiveElement_current = lastActiveElement.current) == null ? void 0 : _lastActiveElement_current.focus({
                preventScroll: true
            });
        }
    };
    useDidUpdate(function() {
        var timeout = -1;
        var clearFocusTimeout = function(event) {
            if (event.key === "Tab") {
                window.clearTimeout(timeout);
            }
        };
        document.addEventListener("keydown", clearFocusTimeout);
        if (opened) {
            lastActiveElement.current = document.activeElement;
        } else if (shouldReturnFocus) {
            timeout = window.setTimeout(returnFocus, 10);
        }
        return function() {
            window.clearTimeout(timeout);
            document.removeEventListener("keydown", clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}

export { useFocusReturn };
